export const FOOTER_ACTION_SET = 'FOOTER_ACTION_SET';
export const FOOTER_ACTION_REMOVE = 'FOOTER_ACTION_REMOVE';

export class FooterActionRemove {
  readonly type = FOOTER_ACTION_REMOVE;
}



// WEBPACK FOOTER //
// ./src/app/store/actions/footer.action.ts